import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
// import { browserHistory } from 'react-router';
import * as SVGICONS from '../../../images/img/images';
// import Moment from 'react-moment';
// import Pagination from "react-js-pagination";
// import * as constant from '../../../constants/constant';
import * as AdminauthAction from '../../../actions/admin/auth/adminauthAction.js';
import autoBind from 'auto-bind';
import validator from './../../common/validator.js';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Forgot from '../../common/forgotPassword';
import OtpModal from '../../login/otp';

import axios from 'axios';
var countries = require('country-data').countries

import {
	Modal
} from 'react-bootstrap';
// import ShowMore from 'react-show-more';
// import '../../styles/css/style.css';

class AdminAuth extends React.Component {
	constructor(props, context) {
		super(props, context);
		autoBind(this);
		this.state = {
			forgotModalOpen: false,
			email: { value: '', isValid: true, message: '' },
			password: { value: '', isValid: true, message: '' },
			spinner: false,
			otpModalOpen:false,
			loginData:{}
		}
		this.openForgotModal = this.openForgotModal.bind(this)
		this.closeForgotModal = this.closeForgotModal.bind(this)
		this.hideForgotModal = this.hideForgotModal.bind(this)
		this.openOtpModal = this.openOtpModal.bind(this);
		this.closeOtpModal = this.closeOtpModal.bind(this);
	}
	openOtpModal(data) {
		// debugger
		this.setState({ otpModalOpen: true, signInModelOpen: false,loginData:data });
	}
	closeOtpModal() {
		this.setState({ otpModalOpen: false, signInModelOpen: true });
	}
	resetValidationStates() {
		var state = this.state;
		Object.keys(state).map(key => {
			if (state[key].hasOwnProperty('isValid')) {
				state[key].isValid = true;
				state[key].message = '';
			}
		});
		this.setState(state);
	}
	onChange(e) {
		var state = this.state;
		state[e.target.name].value = e.target.value;
		this.resetValidationStates();
		if (e.target.name == "email") {
			if (e.target.value.length > 0) {
				if (!validator.isEmail(state.email.value)) {
					state.email.isValid = false;
					state.email.message = 'Not a valid email address';
					this.setState(state);
				} else {
					return true
				}
			} else {
				state.email.isValid = false;
				state.email.message = 'Email address is required';
				this.setState(state);
			}

		} else
			if (e.target.name == "password") {
				if (e.target.value.length > 0) {
					if (!validator.isValid(state.password.value)) {
						state.password.isValid = false;
						state.password.message = 'Not a valid password';
						this.setState(state);
					} else {
						return true
					}
				} else {
					state.password.isValid = false;
					state.password.message = 'Password is required';
					this.setState(state);
				}
			} else if (e.target.name == "userType") {
				return true
			}

		this.setState(state);
	}

	//Handler for sign-in
	onSigninHandler(event) {

		event.preventDefault();
		var state = this.state;
		if (!validator.isValid(state.email.value)) {
			state.email.isValid = false;
			state.email.message = 'Email address is required';
			this.setState(state);
		} else {
			state.email.isValid = true;
			state.email.message = '';
		}
		if (!validator.isValid(state.password.value)) {
			state.password.isValid = false;
			state.password.message = 'Password is required';
			this.setState(state);
		} else {
			state.password.isValid = true;
			state.password.message = '';
		}
		if (this.state.email.value != '' && this.state.password.value != '' && (this.state.email.message == '' || this.state.email.message == undefined) && (this.state.password.message == '' || this.state.password.message == undefined)) {
			var signin = {
				email: this.state.email.value,
				password: this.state.password.value,
			}
			this.setState({ spinner: true })
			this.props.actions.adminLogin(signin);

		}
	}

	formIsValid() {

		var state = this.state;
		// this.resetValidationStates();
		if (!validator.isValid(parseInt(state.userType.value))) {
			console.log('in if usertype')
			state.userType.isValid = false; //this will trigger the has-error class
			state.userType.message = 'Please select user type'; //will be displayed in the
			this.setState(state);
			return false;
		} else
			if (!validator.isValid(state.email.value)) {
				state.email.isValid = false; //this will trigger the has-error class
				state.email.message = 'Email address is required'; //will be displayed in the
				this.setState(state);
				return false;
			} else if (!validator.isValid(state.password.value)) {
				state.password.isValid = false; //this will trigger the has-error class
				state.password.message = 'Password is required'; //will be displayed in the
				this.setState(state);
				return false;
			}
		return true;
	}
	componentWillMount() {
		if(localStorage.getItem('user')){
			this.props.history.push('/')
		}

	}
	componentWillReceiveProps(nextProps) {
		console.log("---**7777", nextProps)
		if (nextProps.signinFail && !nextProps.signinFail.success) {
			this.setState({ spinner: false })
		}
		if(nextProps.signinFail && nextProps.signinFail.token){
			this.setState({
				otpModalOpen:true,
				loginData: {
					...nextProps.signinFail,
					signinData: {
						email: this.state.email.value.toLowerCase(),
						password: this.state.password.value,
						// userType: parseInt(this.state.userType.value),
						Ip: this.state.Ip
					}
					
				}
			})
		}

	}
	componentDidMount() {

		navigator.geolocation.getCurrentPosition(
			function (position) {
				console.log('poiton___________________>', position);
				var lat = position.coords.latitude;
								var lng = position.coords.longitude;
								console.log('lat:- ', lat, ' --> Long:- ', lng);
								localStorage.setItem('lat', lat);
								localStorage.setItem('lng', lng);
								axios.get('https://maps.googleapis.com/maps/api/geocode/json?latlng=' + lat + "," + lng + '&key=AIzaSyBQQtO5Ia-kb95LB-pBnKeBDeN35Z2ybbk')
								.then(function (response) {
									if (response) {
										console.log(response)
										for (var i = 0; i < response.data.results.length; i++) {
											if (response.data.results[i].types[0] == 'country') {
												var countryshort = response.data.results[i].address_components[0].short_name;
												var countrylong = response.data.results[i].address_components[0].long_name;
												console.log('countryshort:- ', countryshort);
												console.log('countrylong:- ', countrylong);
												console.log('currency:- ', countries[countryshort].currencies[0]);
												console.log('calling_code:- ', countries[countryshort].countryCallingCodes[0]);

												localStorage.setItem('country_short', countryshort)
												localStorage.setItem('country_long', countrylong)
												localStorage.setItem('currency', countries[countryshort].currencies[0]);
												localStorage.setItem('calling_code', countries[countryshort].countryCallingCodes[0]);
											}
										}
									}
									else {
									}
								})
			});

	}
	openForgotModal() {

		this.setState({ forgotModalOpen: true });
	}
	closeForgotModal() {
		this.setState({ forgotModalOpen: false, signInModelOpen: true });
	}
	hideForgotModal() {
		this.setState({ forgotModalOpen: false });

	}
	render() {

		var { email } = this.state;
		//var emailGroupClass = classNames('input-group', { 'has-error': !email.isValid });
		return (

			<div>
				<nav className="navbar navbar-expand-md  navbar-default fixed-top navbar-fixed-top sticky">
					<Link className="navbar-brand logo" to="/">
						<img src={require('../../../images/images/logo.svg')} width="185" alt="" />
					</Link>
					<button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
						<span className="navbar-toggler-icon"><i className="fa fa-align-justify"></i></span>
					</button>

					<div className="collapse navbar-collapse flex-row-reverse" id="navbarSupportedContent">
					</div>
				</nav>
				<ToastContainer />

				<section className="home-banner">
					<div className="container">
						<div className="row">
							<div className="col-sm-12">
								<div className="banner-content">
									<div className="banner-heading">
										<h1>Admin</h1>

									</div>
									<div className="banner-form">
										<form className="signup-form" onSubmit={this.onSigninHandler}>
											<div className="loginInput">
												<div className="input-group inputBg admininputInfo">

													<span className="form-icon">
														<SVGICONS.EmailSvg />
													</span>

													<input type="text" name="email" className="form-control adminInput"
														placeholder="Email address" value={this.state.email.value} onChange={this.onChange} autoFocus />
													<span className="help-block">{this.state.email.message}</span>
												</div>
											</div>
											<div className="input-group inputBg admininputInfo">

												<span className="form-icon">
													<SVGICONS.PasswordSvg />
												</span>

												<input type="password" name="password" className="form-control adminInput"
													placeholder="Password" value={this.state.password.value} onChange={this.onChange} autoFocus />
												<span className="help-block">{this.state.password.message}</span>
											</div>
											{/* <div className="form-group">
												<div className="input-group-prepend">
													<span className="input-group-text" id="inputGroupPrepend">
														<SVGICONS.EmailSvg />
													</span>
												</div>
												<input type="text" name="email" className="form-control"
													placeholder="Email address" value={this.state.email.value} onChange={this.onChange} autoFocus />
												<span className="help-block">{this.state.email.message}</span>
											</div>
											<div className="form-group">
												<div className="input-group-prepend">
													<span className="input-group-text" id="inputGroupPrepend">
														<SVGICONS.PasswordSvg />
													</span>
												</div>
												<input type="password" name="password" className="form-control"
													placeholder="Password" value={this.state.password.value} onChange={this.onChange} />
												<span className="help-block">{this.state.password.message}</span>
											</div> */}
											<div className="form-group">
												<button type="submit" className="btn btn-primary btn-search">Sign In{this.state.spinner == true ? <i className="fa fa-spinner fa-spin" /> : ""}</button>
											</div>

											<Link  onClick={this.openForgotModal} className="forgetPass" >
												Forgot Password?</Link>
										</form>


									</div>
									{this.state.otpModalOpen ? <OtpModal {...this.props} otpModalOpen={this.state.otpModalOpen} loginData={this.state.loginData} 	closeOtpModal={this.closeOtpModal} /> : ''}

									{this.state.forgotModalOpen ? <Forgot {...this.props} forgotModalOpen={this.state.forgotModalOpen} hideForgotModal={this.hideForgotModal} closeForgotModal={this.closeForgotModal} /> : ''}

								</div>
							</div>
						</div>
					</div>

				</section>

			</div >
		);
	}
}

//this tells what state should expose on props
function mapStateToProps(state, ownProps) {
	return {
		signinFail: state.signin.signinFail

	};
}
//this tells what action should expose on props
//bindActionCreators is used to bind all actions at once
function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(AdminauthAction, dispatch),
	};
}
export default connect(mapStateToProps, mapDispatchToProps)(AdminAuth);
